export const selectToastsListState = state => state.toasts;
export const selectToastsListMessages = state =>
  selectToastsListState(state).messages;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ToastsList/ToastsListSelectors.js